import "./AboutUs.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import GenerationsInPrint from "./sections/GenerationsInPrint";
import ArtisanalCraftsmanship from "./sections/ArtisanalCraftsmanship";
import WhyItsATouchOfLove from "./sections/WhyItsATouchOfLove";
import Footer from "@/reusable_sections/Footer";
export default function AboutUs() {
  return <div>
      <MainNavigationHeader />
      <GenerationsInPrint />
      <ArtisanalCraftsmanship />
      <WhyItsATouchOfLove />
      <Footer />
    </div>;
}